import { useTranslation } from "react-i18next";

import { CentinelaAvatar } from "../../../components/base/CentinelaChat";
import { cn } from "../../../components/ui/cn";
import { usePrefersReducedMotion } from "../../../hooks/usePrefersReducedMotion";

export interface TabLoaderProps {
  label?: string;
}

export default function TabLoader({ label }: TabLoaderProps) {
  const { t } = useTranslation("common");
  const prefersReducedMotion = usePrefersReducedMotion();

  return (
    <div className="flex flex-col items-center justify-center gap-3 py-12">
      <span className="relative flex h-14 w-14 items-center justify-center" role="status">
        <span
          className={cn(
            "absolute inset-0 rounded-full border border-primary-500/40 border-t-transparent",
            !prefersReducedMotion && "animate-spin [animation-duration:1.6s]",
          )}
        />
        <span
          className={cn(
            "absolute inset-[6px] rounded-full border border-info/30 border-b-transparent",
            !prefersReducedMotion && "animate-spin [animation-direction:reverse] [animation-duration:2.4s]",
          )}
        />
        <CentinelaAvatar size="md" />
      </span>
      <p className="text-xs text-content-faint">{label ?? t("monitoreoIa.units.loadingTab")}</p>
    </div>
  );
}
